// extracted by mini-css-extract-plugin
export default {"title":"fu3to","dateLocation":"KqFVr","LEFT":"DM09+","left":"DM09+","CENTER":"z9bQ8","center":"z9bQ8","RIGHT":"FpSc2","right":"FpSc2"};